export const BASEURL=`https://hiway-solution.com/moma/api/`;